import React from 'react'
import styled from '@emotion/styled'
import { navigate } from 'gatsby'
import ColorButton from 'src/components/atoms/ColorButton'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import FadeDownWrap from 'src/components/atoms/FadeDown'
import { Typography } from 'src/components/atoms/Typography'
import { Image } from 'src/components/atoms/Image'
import { vwSize } from 'src/utils/vwCss'

const PaperCard = ({ linkTo, imageFluid, subtitle }) => {
  const handleClick = () => navigate(linkTo)
  return (
    <Card onClick={handleClick}>
      <FadeDownWrap>
      <CardInner>
        <Thumbnail imageFluid={imageFluid} />
        <SubTitleWrap>
          <SubTitle as="h3">
            {subtitle.split('\n').map((str, index) => (
              <React.Fragment key={index}>
                {str}
                <br />
              </React.Fragment>
            ))}
          </SubTitle>
        </SubTitleWrap>
        <ButtonWrapper>
          <ButtonText>ダウンロード</ButtonText>
        </ButtonWrapper>
      </CardInner>
      </FadeDownWrap>
    </Card>
  )
}

const Card = styled.a`
  display: block;
  box-sizing: border-box;
  width: ${vwSize(252, 'pc')}vw;
  height: ${vwSize(335, 'pc')}vw;
  filter: box-shadow(8px 8px 20px rgba(112, 181, 197, 0.15));
  border-radius: ${Styles.pc.borderRadius};
  overflow: hidden;
  text-decoration: none;
  background: ${Styles.color.grayscale[100]};
  cursor: pointer;
  transition: all 0.1s ease-in;

  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    width: ${vwSize(158, 'sp')}vw;
    height: ${vwSize(274, 'sp')}vw;
    border-radius: ${Styles.sp.borderRadius};
    margin-bottom: ${vwSize(24, 'sp')}vw;
  }

  &:hover {
    opacity: 0.6;
    transform: scale(1.05);
  }

  > div {
    box-sizing: border-box;
    height: 100%;
  }
`
const CardInner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  box-sizing: border-box;
  height: 100%;
`

const Thumbnail = styled(Image)`
`
const SubTitleWrap = styled.div`
  background: ${Styles.color.grayscale[100]};
  box-sizing: border-box;
  padding: 0 ${vwSize(8, 'pc')}vw;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    padding: 0 ${vwSize(8, 'sp')}vw;
  }
`
const SubTitle = styled(Typography)`
  color: ${Styles.color.primary[400]};
  font-size: ${Styles.pc.fontSize.text};
  line-height: ${Styles.lineHeight[350]};
  font-weight: ${Styles.fontWeight.bold};
  text-align: center;
  letter-spacing: ${Styles.pc.letterSpacing};
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    font-size: ${Styles.sp.fontSize.tag};
  }
`
const ButtonWrapper = styled.div`
  background: ${Styles.color.secondary[300]};
  text-align: center;
  padding: ${vwSize(8, 'pc')}vw 0;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    padding: ${vwSize(8, 'sp')}vw 0;
  }
`
const ButtonText = styled(Typography)`
  display: inline;
  color: ${Styles.color.grayscale[100]};
  font-size: ${vwSize(18, 'pc')}vw;
  font-weight: ${Styles.fontWeight.bold};
  line-height: ${Styles.lineHeight[350]};
  letter-spacing: ${Styles.pc.letterSpacing};
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    font-size: ${Styles.sp.fontSize.h3};
  }
`

export default PaperCard
